import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../context/auth";
import { Toasts } from "../toasts";
// TABLES
import TablaBancos from "./tablaBancos";
import TablaCuentasBancarias from "./tablaCuentaaBancaria";
import TablaTipoRetenciones from "./TablaRetenciones";
import TablaEgresos from "./tablaEgresos";
import TablaDevolverOrdenPago from "./tablaDevolverOrdenPago";
import TablaOrdenesdePagos from "./tablaOrdenesdePagos";
import TablaMovimientosBancos from "../hacienda/caja/notasCredito";
import TablaTransferenciasBancarias from "./tablaTransferenciasBancarias";
import TablaAprobarOrdenPago from "./tablaAprobarOrdenPago";
import TablaDesaprobarCompromisos from "./tablaDesaprobarCompromiso";
import TablaConciliacionBancaria from "./tablaConsiliacion";
import TablaSolicitudTrasladoFondos from "./tablaSolicitudTrasladoFondos";
import TablaEnviarSolicitudTraslado from "./tablaEnviarSolicitudTraslado";
import TablaEnterarSolicitud from "./tablaEnterarFondosTerceros";
import TablaEgresoDespacho from "./tablaEnviarEgresoDespacho";
import TablaEgresosAnulado from "./tablaEgresosAnulados";
import TablaCargarOrdenesPagar from "./tablaCargarOrdenesxPagar";
import TablaAprobarOrdenCompra from "./tablaAprobarOrdenCompra";
import TablaDevolverEmiEgre from "./tablaDEvolverPagoEmisionEgreso";
import TablaOrdenesdePagosF from "./tablaOrdenesdePagosF";
import TablaFondoAvance from "./tablaFondoAvance";
import TablaUsuarioAdministracion from "./tablaUsuarioAdministracion";
// MODALS
import { ImpMovBanLibro } from "./impMovBanSegunLibro";
import { ImpRetenciones } from "./impRetenciones";
import { ImpXml } from "./impXml";
import { ImpTxtIva } from "./impTxtIva";
import CambiarEfiscal from "../configuracionGeneral/modalCambiarEfiscal";
import { CambiarClaveSupervisor } from "../comun/modalCambiarClaveSupervisor";
// MENU COMPONENTES
import Menu from "../comun/Menu/Menu";
import Item from "../comun/Menu/Item";
import imgAdmin from "../../imagenes/fd_administracion.png";
import Footer from "../Footer";
import ImprimirConsiliaciones from "./modalImprimirConsiliaciones";
import { ImpOrdenesPago } from "./impOrdenesPago";
import { ImpEjeFinanciera } from "./impEjecucionFinanciera";
import { ImpBancos } from "./impBancos";
import { ImpModalRetenciones } from "./impRetencionesModal";
import { ImpEjeFinanciera2 } from "./impRetenciones2";
import { ImpEjeFinanciera3 } from "./impRetenciones3";
import { ModalImprimirComprobantesIva } from './modalImprimirComprobantesIva'
import TablaSecuenciaPlanilla from "./TablaSecuenciaPlanilla";
function MenuPrincipaAdmin() {
  const login = JSON.parse(localStorage.getItem("post")).login
  const { user } = useContext(AuthContext);

  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  const accbanco = JSON.parse(localStorage.getItem('accbanco')) === null ? "0000" : JSON.parse(localStorage.getItem('accbanco')).trim();
  const acccuentabancaria = JSON.parse(localStorage.getItem('acccuentabancaria')) === null ? "0000" : JSON.parse(localStorage.getItem('acccuentabancaria')).trim();
  const acctiporetencion = JSON.parse(localStorage.getItem('acctiporetencion')) === null ? "0000" : JSON.parse(localStorage.getItem('acctiporetencion')).trim();
  const acccausar = JSON.parse(localStorage.getItem("acccausar")) === null ? "" : JSON.parse(localStorage.getItem("acccausar")).trim();
  const acccambioefiscal = JSON.parse(localStorage.getItem("acccambioefiscal")) === null ? "" : JSON.parse(localStorage.getItem("acccambioefiscal")).trim();
  const accadministrador = JSON.parse(localStorage.getItem("accadministrador")) === null ? "" : JSON.parse(localStorage.getItem("accadministrador")).trim();
  const accrepbanco = JSON.parse(localStorage.getItem("accrepbanco")) === null ? "" : JSON.parse(localStorage.getItem("accrepbanco"));
  const accrepretencion = JSON.parse(localStorage.getItem("accrepretencion")) === null ? "" : JSON.parse(localStorage.getItem("accrepretencion"));
  const accrepordenpago = JSON.parse(localStorage.getItem("accrepordenpago")) === null ? "" : JSON.parse(localStorage.getItem("accrepordenpago"));
  const accegresos = JSON.parse(localStorage.getItem("accegresos")) === null ? "" : JSON.parse(localStorage.getItem("accegresos"));
  const acctransferenciabanc = JSON.parse(localStorage.getItem("acctransferenciabanc"))  === null ? "" : JSON.parse(localStorage.getItem("acctransferenciabanc"));
  const accconciliacion = JSON.parse(localStorage.getItem("accconciliacion")) === null ? "" : JSON.parse(localStorage.getItem("accconciliacion"));
  const accmovtransito = JSON.parse(localStorage.getItem("accmovtransito")) === null ? "0000" : JSON.parse(localStorage.getItem("accmovtransito"));
  const accfondotercero = JSON.parse(localStorage.getItem("accfondotercero")) === null ? "0" : JSON.parse(localStorage.getItem("accfondotercero"));
  const accaproborden = JSON.parse(localStorage.getItem("accaproborden")) === null ? "0" : JSON.parse(localStorage.getItem("accaproborden"));
  const superadmin = JSON.parse(localStorage.getItem("superadmin"));
  const superteso = JSON.parse(localStorage.getItem("superteso"));
  const accusuarioadmini = JSON.parse(localStorage.getItem('accusuarioadmini')) === null ? "0000" : JSON.parse(localStorage.getItem('accusuarioadmini')).trim();

  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );
  const [mostrar, setMostrar] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [mostrar6, setMostrar6] = useState(false);

  const [reprote, setReporte] = useState("");
  let op = require("../../../src/modulos/datos");

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);

    if (obj != null) {
      setFechaSistema(obj.fechasistema);
      var nanio = [];
      var aini = parseInt(obj.anioactu) - 7;
      var afin = parseInt(obj.anioactu);
      for (let i = 1; i <= afin - aini; i++) {
        nanio.push({ anio: aini + i });
      }
    } else {
    }
  }, []);
  // PERMISOS
  const [cambiarAnioFiscalPermission, setCambiarAnioFiscalPermission] =
    useState(false);
  const [egresosPermission, setEgresosPermission] = useState(false);
  const [fondosTercerosPermission, setFondosTercerosPermission] =
    useState(false);
  const [ordenesPagosPermission, setOrdenesPagosPermission] = useState(false);
  const [administradorPermission, setAdministradorPermission] = useState(false);
  const [bancoPermission, setBancoPermission] = useState(false);
  const [retencionesPermission, setRetencionesPermission] = useState(false);
  const [devolver, setDevolver] = useState('1');
  // CHECK PERMISOS
  useEffect(() => {
    setCambiarAnioFiscalPermission(false);
    setEgresosPermission(false);
    setFondosTercerosPermission(false);
    setOrdenesPagosPermission(false);
    setAdministradorPermission(false);
    setBancoPermission(false);
    setRetencionesPermission(true);
    if (acccambioefiscal === "1") setCambiarAnioFiscalPermission(true);
    if (accegresos === "1") setEgresosPermission(true);
    if (accfondotercero === "1") setFondosTercerosPermission(true);
    if (acccausar === "1") setOrdenesPagosPermission(true);
    if (accadministrador === "1") setAdministradorPermission(true);
    if (accbanco === "1") setBancoPermission(true);
    if (acctiporetencion === "1") setRetencionesPermission(true);
  }, [accegresos, acccambioefiscal, accfondotercero, acccausar, accadministrador, accbanco, acctiporetencion]);
  // ITEMS
  const intalacionItem = {
    title: "Instalacion",
    icon: "fa fa-share-square me-2",
    permission: accbanco === "0000"  && acccuentabancaria === "0000" && acctiporetencion === "0000" ? false : true,
    drop: [
      {
        title: "Bancos",
        icon: "fas fa-university me-2",
        itemClickValue: 1,
        permission: accbanco === "0000" ? false : true,
      },
      {
        title: "Cuentas bancarias",
        icon: "fas fa-list-alt me-2",
        itemClickValue: 2,
        permission: acccuentabancaria === "0000" ? false : true,
      },
      {
        title: "Retenciones",
        icon: "fas fa-hand-holding me-2",
        itemClickValue: 3,
        permission: acctiporetencion === "0000" ? false : true,
      },
      {
        title: "Cambio año presupuesto",
        icon: "fa fa-calendar me-2",
        itemClickValue: 99,
        permission: cambiarAnioFiscalPermission,
      },
    ],
  };
  const administracionItem = {
    title: "Administracion",
    icon: "fas fa-cash-register me-2",
    drop: [
      {
        title: "Emision egresos »",
        icon: "fas fa-angle-double-right me-2",
        permission: egresosPermission,
        subDrop: [
          {
            title: "Impresion de egresos",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 4,
          },
          {
            title: "Devolver orden de pago administracion",
            icon: "fas fa-digital-tachograph me-2",
            itemClickValue: 5,
          },
          /* {
            title: "Enviar egreso a tesoreria",
            icon: "fas fa-digital-tachograph me-2",
            itemClickValue: 6,
          },
          {
            title: "Devolver pago de emision de egreso",
            icon: "fas fa-digital-tachograph me-2",
            itemClickValue: 7,
          }, */
        ],
      },
      {
        title: "Transferencias bancarias",
        icon: "fas fa-exchange-alt me-2",
        itemClickValue: 8,
      },
      {
        title: "Conciliacion bancaria",
        icon: "fas fa-file-invoice me-2",
        itemClickValue: 221,
      },
      {
        title: "Fondos a terceros »",
        icon: "fas fa-angle-double-right me-2",
        permission: fondosTercerosPermission,
        subDrop: [
          {
            title: "Solicitud de traslado de fondos",
            icon: "fas fa-digital-tachograph me-2",
            itemClickValue: 9,
          },
          {
            title: "Enviar traslado de fondos",
            icon: "fas fa-digital-tachograph me-2",
            itemClickValue: 10,
          },
          {
            title: "Enterar Fondos de Terceros (Orden Pago)",
            icon: "fas fa-digital-tachograph me-2",
            itemClickValue: 11,
          },
        ],
      },
      {
        title: "Movimientos bancarios",
        icon: "fas fa-piggy-bank me-2",
        itemClickValue: 13,
      },
      {
        title: "Ordenes de pago",
        icon: "fas fa-angle-double-right me-2",
        permission: ordenesPagosPermission,
        subDrop: [
          {
            title: "Orden de pago",
            icon: "fas fa-money-check me-2",
            itemClickValue: 14,
          },
          {
            title: "Aprobar orden de pago",
            icon: "fas fa-money-check me-2",
            itemClickValue: 15,
            permission: accaproborden === "1" ? true : false,
          },
          {
            title: "Desaprobar Compromisos",
            icon: "fas fa-money-check me-2",
            itemClickValue: 16,
            permission: accaproborden === "1" ? true : false,
          },
          {
            title: "Cargar ordenes por pagar",
            icon: "fas fa-money-check me-2",
            itemClickValue: 17,
          },
        ],
      },
      {
        title: "Administrador »",
        icon: "fas fa-angle-double-right me-2",
        permission: administradorPermission,
        subDrop: [
          {
            title: "Aprobar ordenes de compra/servicios",
            icon: "fas fa-money-check me-2",
            itemClickValue: 18,
          },
          {
            title: "Desaprobar ordenes de compra/servicios",
            icon: "fas fa-money-check me-2",
            itemClickValue: 19,
          },
          {
            title: "Devolver Solicitud de Traslado de Fondo de Terceros",
            icon: "fas fa-money-check me-2",
            itemClickValue: 30,
          },
          {
            title: "Ordenes de pago financieras",
            icon: "fas fa-money-check me-2",
            itemClickValue: 20,
          },
          {
            title: "Fondos en avance",
            icon: "fas fa-money-check me-2",
            itemClickValue: 21,
          },
        ],
      },
      {
        title: 'Secuencia Planilla',
        icon: "fas fa-angle-double-right me-2",
        itemClickValue: 999,
      }
    ],
  };
  const reportesItem = {
    title: "Reportes",
    icon: "fas fa-print me-2",
    permission: accrepordenpago === "1" ? true : false,
    drop: [
      {
        title: "Ordenes de Pago »",
        icon: "fas fa-angle-double-right me-2",
        permission: accrepordenpago === "1" ? true : false,
        subDrop: [
          {
            title: "Listado General de Ordenes de Pago",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 100,
          },
          {
            title: "Listado Detallao de Compromisos",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 101,
          },
          {
            title: "Ordenes de Pago por tipo de Compromiso",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 102,
          },
          {
            title: "Ordenes de Pago por Beneficiario",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 103,
          },
          {
            title: "Resumen de Cuentas por Pagar",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 104,
          },
          {
            title: "Ubicacion de Compromisos",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 105,
          },
          {
            title: "Ubicacion de Ordenes de Pago",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 106,
          },
          {
            title: "Listado General de Pagos x Proveedor",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 107,
          },
          {
            title: "Ordenes de Pago Financiera por Tipo",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 108,
          },
        ],
      },
      {
        title: "Ejecucion Financiera »",
        icon: "fas fa-angle-double-right me-2",
        subDrop: [
          {
            title: "Partidas x Orden de Pago",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 109,
          },
          {
            title: "Partidas x Orden de Pago (Cuenta PUC)",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 110,
          },
        ],
      },
      {
        title: "Bancos »",
        icon: "fas fa-angle-double-right me-2",
        permission: accrepbanco === "1" ? true : false,
        subDrop: [
          {
            title: "Saldo en Bancos",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 111,
          },
          {
            title: "Movimientos banco segun libro",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 22,
          },
          {
            title: "Movimientos segun banco",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 112,
          },
          {
            title: "Relacion de Egreso",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 118,
          },
          {
            title: "Resumen de Gastos",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 113,
          },
          {
            title: "Egresos Emitidos (Por tipo de Documento)",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 114,
          },
          {
            title: "Transferencias Bancarias",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 115,
          },
          {
            title: "Depositos Bancarios",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 116,
          },
          {
            title: "Conciliaciones",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 27,
          },
          {
            title: "Movimientos Conciliados",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 28,
          },
          {
            title: "Momivientos Por conciliar",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 29,
          },
          {
            title: "Notas de Debito y de Credito",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 117,
          },
        ],
      },
      {
        title: "Retenciones »",
        icon: "fas fa-angle-double-right me-2",
        permission: accrepretencion === "1" ? true : false,
        subDrop: [
          {
            title: "Generar XML",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 23,
          },
          {
            title: "Planilla de retención/orden de pago",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 24,
          },
          {
            title: "Listado de Retenciones",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 119,
          },
          {
            title: "Retenciones Declaradas",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 120,
          },
          {
            title:
              "Retenciones por Trasladar/Trasladadas a Ctas Fondo de Terceros",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 121,
          },
          {
            title: "Retenciones por Enterar por Proveedor (Fondo de Terceros)",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 122,
          },
          {
            title: "Retenciones Enteradas por Proveedor (Fondo de Terceros)",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 123,
          },
          {
            title: "Retenciones Realizadas - Agrupadas por Bancos",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 124,
          },
          {
            title: "Resumen de Retenciones Anuales por Beneficiario",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 125,
          },
          {
            title: "Comprobante de Retenciones Varias",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 126,
          },
          {
            title: "Generar Archivo Texto IVA",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 25,
          },
          {
            title: "Rendicion Informativa Impuesto 1x500",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 127,
          },
          {
            title: "Rendcion Impuesto Actividades Económicas",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 128,
          },
          {
            title: "Listado de Comprobantes de IVA",
            icon: "fas fa-file-alt me-2",
            itemClickValue: 129,
          },
        ],
      },
    ],
  };
  const configuracionItem = {
    title: "Configuracion",
    icon: "fa fa-cog me-2",
    drop: [
      {
        title: "Usuarios",
        icon: "fa fa-user me-2",
        itemClickValue: 26,
      },
      {
        title: "Cambiar Clave Supervisor Administracion",
        icon: "fa fa-user-tie me-2",
        itemClickValue: 227,
        permission: superadmin,
      },
      {
        title: "Cambiar Clave Supervisor Tesoreria",
        icon: "fa fa-user-shield me-2",
        itemClickValue: 228,
        permission: superteso,
      },
    ],
  };
  
  const [tabla, setTabla] = useState(0);
  const [show, setShow] = useState(false);

  const PorDefecto = () => {
    const azulProfundo = "#003a70";
    const azulVibrante = "#007bff";

    return (
      <section
        className="col-12 m-0 p-0"
        style={{ height: "90dvh", overflow: "hidden" }}
      >
        <style>{`
          @keyframes float {
            0% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
            50% { transform: translateY(-20px) translateX(10px); opacity: 1; }
            100% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
          }
          .tech-dot {
            position: absolute;
            background: white;
            border-radius: 50%;
            animation: float 6s infinite ease-in-out;
          }
        `}</style>

        <div
          className="col-md-12 row mx-auto px-0"
          style={{ minHeight: "100%" }}
        >
          <div
            className="col-md-6 d-flex justify-content-center align-items-center"
            style={{
              position: "relative",
              left: "-50px",
              borderBottomRightRadius: "30%",
              height: "90dvh",
              backgroundColor: azulProfundo,
              overflow: "hidden",
              boxShadow: "10px 0 30px rgba(0,0,0,0.2)",
            }}
          >
            {/* 1. FONDO MESH GRADIENT (Profundidad) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: `
                radial-gradient(circle at 20% 30%, ${azulVibrante} 0%, transparent 50%),
                radial-gradient(circle at 80% 70%, #00d4ff 0%, transparent 50%),
                ${azulProfundo}
              `,
              }}
            />

            {/* 2. REJILLA TECNOLÓGICA (Grid lines) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundImage: `linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), 
                                linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)`,
                backgroundSize: "50px 50px",
              }}
            />

            {/* 3. PUNTOS ANIMADOS (Partículas) */}
            <div
              className="tech-dot"
              style={{
                width: "6px",
                height: "6px",
                top: "20%",
                left: "15%",
                animationDelay: "0s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "4px",
                height: "4px",
                top: "60%",
                left: "25%",
                animationDelay: "1s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "8px",
                height: "8px",
                top: "40%",
                left: "80%",
                animationDelay: "2s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "3px",
                height: "3px",
                top: "80%",
                left: "60%",
                animationDelay: "1.5s",
              }}
            />

            {/* 4. RÁFAGAS DE LUZ DIAGONALES */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 20%, rgba(255,255,255,0.05) 50%, transparent 100%)",
                transform: "skewX(-20deg)",
              }}
            />

            {/* LOGO CON GLOW */}
            <div
              style={{ position: "relative", zIndex: 10, textAlign: "center" }}
            >
              <img
                style={{
                  filter: "drop-shadow(0px 0px 30px rgba(255,255,255,0.3))",
                  maxWidth: "100%",
                  transition: "transform 0.3s ease",
                }}
                className="img-fluid"
                src={imgAdmin}
                alt="Logo SIAP"
              />
            </div>
          </div>

          {/* LADO DERECHO (Alcaldía) */}
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <img
              className="img-fluid px-5"
              src={op.imagenes + "/imagen?img=" + op.logohacienda}
              alt="Logo Alcaldía"
              style={{ maxWidth: "85%" }}
            />
          </div>
        </div>
      </section>
    );
  };
  const vista = {
    0: <PorDefecto />,
    1: <TablaBancos setTabla={setTabla} />,
    2: <TablaCuentasBancarias setTabla={setTabla} />,
    3: <TablaTipoRetenciones setTabla={setTabla} />,
    4: <TablaEgresos setTabla={setTabla} />,
    5: <TablaDevolverOrdenPago setTabla={setTabla} />,
    6: <TablaEgresosAnulado setTabla={setTabla} />,
    7: <TablaDevolverEmiEgre setTabla={setTabla} />,
    8: <TablaTransferenciasBancarias setTabla={setTabla} />,
    9: <TablaSolicitudTrasladoFondos setTabla={setTabla} />,
    10: <TablaEnviarSolicitudTraslado tabla={tabla} setTabla={setTabla} devolver={'1'} />,
    11: <TablaEnterarSolicitud setTabla={setTabla} />,
    12: <TablaEgresoDespacho setTabla={setTabla} />,
    13: <TablaMovimientosBancos setTabla={setTabla} />,
    14: <TablaOrdenesdePagos setTabla={setTabla} />,
    15: <TablaAprobarOrdenPago setTabla={setTabla} ubi={42} dev={1} tip={1} />,
    16: (
      <TablaDesaprobarCompromisos
        ubi={42}
        tipo={0}
        devueltov={0}
        tipocom={0}
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    17: <TablaCargarOrdenesPagar setTabla={setTabla} />,
    18: <TablaAprobarOrdenCompra setTabla={setTabla} />,
    19: <TablaDevolverEmiEgre setTabla={setTabla} />,
    20: <TablaOrdenesdePagosF setTabla={setTabla} />,
    21: <TablaFondoAvance setTabla={setTabla} />,
    22: <ImpMovBanLibro show={show} setShow={setShow} />,
    23: <ImpXml show={show} setShow={setShow} />,
    24: <ImpRetenciones show={show} setShow={setShow} setTabla={setTabla} />,
    25: <ImpTxtIva show={show} setShow={setShow} />,
    26: <TablaUsuarioAdministracion setTabla={setTabla} />,
    // 113: <TablaDepositoBancario/>,
    // 191: <TablaDepositoBancarioTerceros/>,
    221: <TablaConciliacionBancaria setTabla={setTabla}  />,
    99: <CambiarEfiscal show={show} setShow={setShow} setTabla={() => setTabla(0)}/>,
    30: <TablaEnviarSolicitudTraslado tabla={tabla} setTabla={setTabla} devolver={'0'} />,
    227: <CambiarClaveSupervisor supervisor="admin" show={show} setShow={setShow} setTabla={setTabla} login={login}/>,
    228: <CambiarClaveSupervisor supervisor="teso" show={show} setShow={setShow} setTabla={setTabla} login={login}/>,
    129: <ModalImprimirComprobantesIva show={show} setTabla={setTabla}/>,
    999: <TablaSecuenciaPlanilla show={show} setTabla={setTabla} />
  };

  useEffect(() => {
    if (tabla === 1) {
      if (accbanco === "0000") {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
        setTabla(0);
      } 
    } else if (tabla === 2) {
      if (acccuentabancaria === "0000") {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
        setTabla(0);
      } 
    } else if (tabla === 3) {
      if (acctiporetencion === "0000") {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
        setTabla(0);
      } 
    } else if (tabla === 8) {
      if (acctransferenciabanc === "0") {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
        setTabla(0);
      } 
    } else if (tabla === 13) {
      if (accmovtransito === "0000") {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
        setTabla(0);
      } 
    } else if (tabla === 26) {
      if (accusuarioadmini === "0000") {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
        setTabla(0);
      } 
    } else if (tabla === 27 || tabla === 28 || tabla === 29) {
      if (tabla === 28) {
        setReporte("Movimientos Conciliados");
      } else if (tabla === 29) {
        setReporte("Movimientos por Conciliar");
      } else if (tabla === 27) {
        setReporte("Conciliaciones");
      }
      setMostrar(true);
    } else if( tabla === 111){
        let fileName = "Tes_BcoSaldo";
       window.open(
          op.reportes + "/administracionTesoreria?" + // Ajusta la ruta si es necesario
          "reporte=" + fileName,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
        setTabla(0);
    } else if (tabla === 221) {
      if (accconciliacion === "0") {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
        setTabla(0);
      } 
    } 
  }, [tabla]);

  useEffect(() => {
    if (
      tabla === 100 ||
      tabla === 101 ||
      tabla === 102 ||
      tabla === 103 ||
      tabla === 104 ||
      tabla === 105 ||
      tabla === 106 ||
      tabla === 107 ||
      tabla === 108
    ) {
      setMostrar1(true);
    } else if (tabla === 109 || tabla === 110) {
      setMostrar2(true);
    } else if (
      tabla === 112 ||
      tabla === 113 ||
      tabla === 114 ||
      tabla === 115 ||
      tabla === 116 ||
      tabla === 117 ||
      tabla === 118
    ) {
      setMostrar3(true);
    } else if (tabla === 119) {
      setMostrar4(true);
    } else if (tabla === 120 || tabla === 121 || tabla === 122 || tabla === 123 || tabla === 124 || tabla === 125 || tabla === 126) {
      setMostrar5(true);
    } else if (tabla === 127 || tabla === 128) {
      setMostrar6(true);

    } 
    console.log(tabla);
  }, [tabla]);

  return (
    user && (
      <div>
        <Menu fechaSistema={fechaSistema} op={op}>
          <Item item={intalacionItem} setTabla={setTabla} setShow={setShow} />
          <Item
            item={administracionItem}
            setTabla={setTabla}
            setShow={setShow}
          />
          <Item item={reportesItem} setTabla={setTabla} setShow={setShow} />
          <Item
            item={configuracionItem}
            setTabla={setTabla}
            setShow={setShow}
          />
          <a
            href="/inicio"
            className="list-group-item list-group-item-action bg-transparent text-danger fw-bold"
          >
            <i className="fas fa-power-off me-2" />
            Salir
          </a>
        </Menu>
        
           <section className="col-xl-12 m-0 p-0 " style={{ height: "90dvh" }}>
          {vista[tabla]}
        </section>
        <Toasts
          show={toast.mostrar}
          titulo={toast.titulo}
          mensaje={toast.mensaje}
          onHideCancela={cerrarToast}
        />
        <ImprimirConsiliaciones
          show={mostrar}
          onHideCancela={() => {
            (setMostrar(false), setReporte(""), setTabla(0));
          }}
          report={reprote}
        />

        <ImpOrdenesPago
          show={mostrar1}
          reporte={tabla}
          cancelar={() => {
            setMostrar1(false);
            setTabla(0);
          }}
        />
        <ImpEjeFinanciera
          show={mostrar2}
          reporte={tabla}
          cancelar={() => {
            setMostrar2(false);
            setTabla(0);
          }}
        />
        <ImpBancos
          show={mostrar3}
          reporte={tabla}
          cancelar={() => {
            setMostrar3(false);
            setTabla(0);
          }}
        />
        <ImpModalRetenciones
          show={mostrar4}
          reporte={tabla}
          cancelar={() => {
            setMostrar4(false);
            setTabla(0);
          }}
        />

        <ImpEjeFinanciera2
          show={mostrar5}
          reporte={tabla}
          cancelar={() => {
            setMostrar5(false);
            setTabla(0);
          }}
        />
        <ImpEjeFinanciera3
          show={mostrar6}
          reporte={tabla}
          cancelar={() => {
            setMostrar6(false);
            setTabla(0);
          }}
        />
      </div>
    )
  );
}
export default MenuPrincipaAdmin;
